import type { FaireProductEntity } from "../../entity_types/product";

export const p_a5t7kjczx6: FaireProductEntity = {
  token: "p_a5t7kjczx6",
  type: "product",
  name: "KIT VENDÔME BUSTE COUTURE LONG SMALL+",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/ad76a6c32823cd59ef8ebda0b6c59cb3d74b27ae690d1661a614276eec75a911.png",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/30448900cde44c3ff19982b6165ca2c91ae8546531f41140d7ce6aa8aec3ccde.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
